import React, { useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import usePaginationValuesWhere from "../../hooks/usePaginationValuesWhere";
import useExceptionHandler from "hooks/useExceptionHandler";
import useMessage from "hooks/useMessage";
import { RequestLogManager } from "managers";
import { GridView, SvgComponent, Simplebar, InputSidebarContainer } from "components";
import ListHeader from "components/PantallaList/Header/ListHeader";
import IconButton from "components/IconButton/IconButton";
import ToolTip from "components/ToolTip/ToolTip";

export default function RequestLogList({ showLoading, hideLoading }) {
  const [where, setWhere] = useState({});
  const [pagination, setPagination] = useState({
    EsPaginable: true,
    CantidadPorPagina: 15,
    EsOrdernable: true,
    OrderBy: "Id",
  });
  const [list, setList] = useState([]);
  const [currentLog, setCurrentLog] = useState({});
  const [showDetalle, setShowDetalle] = useState(false);
  const ref = useRef(null);
  const { setPaginationValuesWhere } = usePaginationValuesWhere();
  const { handleException } = useExceptionHandler();
  const { cerrarAlertas } = useMessage();

  useEffect(() => {
    buscar();
    return () => {
      cerrarAlertas();
      hideLoading();
    };
  }, [where]);

  const buscar = () => {
    const whereWithPaginationValues = { ...where, ...pagination };
    RequestLogManager.listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        setList(res.Data);
      })
      .catch((error) => {
        handleException(error);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhere({ ...where });
  };

  const handleVerClick = (id) => {
    showLoading();
    RequestLogManager.buscarPorId(id)
      .then((data) => {
        setCurrentLog(data);
        setShowDetalle(true);
      })
      .catch((error) => {
        handleException(error);
      })
      .finally(() => {
        hideLoading();
      });
  };

  return (
    <div>
      <Simplebar
        ref={ref}
        backdrop={true}
        placement={"end"}
        portal={false}
        visible={showDetalle}
        setShow={setShowDetalle}
        useLoading={true}
        title="Detalle Request Log"
        size="xl"
        btnLeft={{ show: false }}
        btnRight={{ show: false }}
      >
        <InputSidebarContainer label="Dirección IP">
          <Form.Control disabled value={currentLog.DireccionIP ?? ""} />
        </InputSidebarContainer>
        <InputSidebarContainer label="Contenido">
          <Form.Control
            as="textarea"
            rows={8}
            style={{ resize: "vertical" }}
            disabled
            value={currentLog.Contenido ?? ""}
          />
        </InputSidebarContainer>
        <InputSidebarContainer label="Respuesta">
          <Form.Control
            as="textarea"
            rows={8}
            style={{ resize: "vertical" }}
            disabled
            value={currentLog.Respuesta ?? ""}
          />
        </InputSidebarContainer>
      </Simplebar>

      <div style={{ paddingRight: "6px" }}>
        <ListHeader titulo={"Request Log"} />
      </div>
      <GridView
        pagination={pagination}
        setPagination={setPagination}
        allowPaging={pagination.EsPaginable}
        pageSize={pagination.CantidadPorPagina}
        pageIndex={pagination.IndiceDePagina}
        lastPageNumber={pagination.PaginasTotal}
        dataSource={list}
        onPageIndexChanging={onPageIndexChanging}
        where={where}
        setWhere={setWhere}
        height="70vh"
      >
        <GridView.Column
          width="100px"
          bodyRenderer={(row) => (
            <div className="float-right">
              <IconButton onClick={() => handleVerClick(row.Id)}>
                <ToolTip message="Ver detalle">
                  <div>
                    <SvgComponent iconName="view" height="25px" width="25px" />
                  </div>
                </ToolTip>
              </IconButton>
            </div>
          )}
        />
        <GridView.Column
          headerText="Id"
          dataField="Id"
          sortExpression="Id"
        />
        <GridView.Column
          headerText="Compañía Id"
          dataField="CompaniaId"
          sortExpression="CompaniaId"
        />
        <GridView.Column
          headerText="Transacción Id"
          dataField="TransaccionId"
          sortExpression="TransaccionId"
        />
        <GridView.Column
          headerText="Fecha Creación"
          dataField="FechaCreacion"
          sortExpression="FechaCreacion"
        />
        <GridView.Column
          headerText="Método"
          dataField="Method"
          sortExpression="Method"
        />
        <GridView.Column
          width="300px"
          headerText="Endpoint"
          dataField="EndPoint"
          sortExpression="EndPoint"
        />
      </GridView>
    </div>
  );
}
